import { render, staticRenderFns } from "./EditHeaderNewChic.vue?vue&type=template&id=6662177d&scoped=true&"
import script from "./EditHeaderNewChic.vue?vue&type=script&lang=js&"
export * from "./EditHeaderNewChic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662177d",
  null
  
)

export default component.exports